<!-- Top Calendar -->
<app-breadcrumbs
	[headerTitle]="'TODAY,' + (todaysDate | date : 'MMMM d, y' | uppercase)"
	[buttonText]="canCreateCalendarOffCycles ? 'CREATE NEW OFFCYCLE' : ''"
	(onHeaderButtonAction)="canCreateCalendarOffCycles ? createOffcycle() : null"
	[buttonIconObj]="breadCrumbIcon"
/>
@if(payGroup) {
<app-calendar
	sub-header
	(onDayClicked)="dayClick($event)"
	(onNoPayCyclesFound)="noPayCycleSelected($event)"
	(onPayCycleChanges)="payCycleChange($event)"
	(onEditCycle)="editCycle($event)"
	[_payGroup]="payGroup"
/>
}
<div class="calendar-main-container">
	@if(payCycleSelected) { @for(group of milestoneGroups; track $index) {
	<app-calendar-event-milestone
		[milestones]="milestones"
		[group]="group"
		[payGroup]="payGroup"
		[payCycle]="payCycleSelected"
		[milestoneGroupSelected]="selectedMilestoneGroups"
		[firstUnconfiguredMilestoneGroup]="firstUnconfiguredMilestoneGroup"
		(onMilestoneGroupSelected)="setMilestoneGroup($event)"
		(viewIconClickedEvent)="openDetails($event)"
		(cardClickedEvent)="openDetails($event)"
	/>
	} } @if(!payCycleSelected){
	<div class="event-no-item">
		<div class="event-no-item-content">The dates covered have no pay cycles.</div>
	</div>
	}

	<!-- NET Creation -->
	@if (showNetCreation) {
	<app-payment-calendar-milestone-creation
		[payCycle]="payCycleSelected"
		[payGroup]="payGroup"
		[date]="dateSelected"
		[milestoneGroup]="milestoneGroupsToCreate!"
		(closed)="onCloseCreation($event)"
	/>
	}

	<!-- NET Edition -->
	@if(showMilestoneEdition) {
	<app-payment-calendar-milestone-edition
		[payCycle]="payCycleSelected"
		[milestone]="milestoneSelected"
		[payGroup]="payGroup"
		(closed)="onCloseEdition($event)"
	/>
	}
</div>
